import React, {createContext} from "react";

export const ResumeDetailInstanceContext = createContext();
